module.exports = __webpack_public_path__ + "static/img/charm_level_86.acabcc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_86.png
// module id = RQBG
// module chunks = 0